import React from 'react'
import PropTypes from 'prop-types'
import cls from 'classnames'

import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import Money from '@cred/react-basic-form-fields/hookForm/Money'
import RadioGroup from '@cred/react-basic-form-fields/hookForm/RadioGroup'
import { required } from '@cred/shared/validations'

import Footer from 'multi-vertical/rate-table/components/filter-modal/footer'
import { minMaxLoanAmount } from 'student-loan/rate-table/validations'

import styles from './styles.module.scss'

const noop = () => {}
const radioOptions = [
  { value: 'borrower', label: 'Student' },
  { value: 'cosigner', label: 'Co-signer' },
]

const FilterForm = ({
  invalid = false,
  update = noop,
  cancel = noop,
  withFooter = false,
  multiVertical = false,
  control,
}) => {
  return (
    <>
      <div
        className={cls(styles.filters, {
          [styles.multivertical]: multiVertical,
        })}
      >
        <div className={styles.radioGroupWrap}>
          <p className="semiBold">I am a:</p>
          <RadioGroup
            id="role"
            name="role"
            className={cls(styles.radioButton)}
            display="grouped"
            borderType="noBorder"
            control={control}
          >
            {radioOptions.map(({ label, value }) => (
              <option label={label} value={value} key={`radio-${value}`} />
            ))}
          </RadioGroup>
        </div>
        <div className={cls(styles.loanAmount)}>
          <Money
            id="loanAmount"
            name="loanAmount"
            label="Loan Amount"
            placeholder="Loan amount"
            control={control}
            controllerProps={{ rules: { validate: { required, minMaxLoanAmount } } }}
            exposeValue
            className={styles.loanAmountInput}
          />
        </div>
      </div>
      {withFooter && <Footer cancel={cancel} invalid={invalid} update={update} />}
      <hr />
    </>
  )
}

FilterForm.propTypes = {
  control: PropTypes.object.isRequired,
  update: PropTypes.func,
  cancel: PropTypes.func,
  invalid: PropTypes.bool,
  withFooter: PropTypes.bool,
  multiVertical: PropTypes.bool,
}

export { FilterForm as FilterFormNoHoc }

export default withSnowplowContexts(FilterForm)
